module.exports = __webpack_public_path__ + "media/images/official/special_migration_10-ceee06c42f349e65a0e4fcc783125318.jpg";